/** Image picker unavailable on PWA v1. */
export const launchImageLibrary = async () => ({ didCancel: true, assets: [] });
export const launchCamera = async () => ({ didCancel: true, assets: [] });
export default { launchImageLibrary, launchCamera };
